var _title, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgRepeat = function SvgRepeat(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Shape")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mockup---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Recurrence-displayed---daily",
    transform: "translate(-1012.000000, -772.000000)",
    fill: "#8295A3",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "container-",
    transform: "translate(360.000000, 162.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "about-event",
    transform: "translate(320.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M351.998648,577.911111 L344.465315,577.911111 L347.509759,574.777778 C344.476426,571.777778 339.565315,571.666667 336.531982,574.666667 C333.498648,577.677778 333.498648,582.533333 336.531982,585.544444 C339.565315,588.555556 344.476426,588.555556 347.509759,585.544444 C349.02087,584.055556 349.776426,582.311111 349.776426,580.111111 L351.998648,580.111111 C351.998648,582.311111 351.02087,585.166667 349.065315,587.1 C345.165315,590.966667 338.831982,590.966667 334.931982,587.1 C331.043093,583.244444 331.009759,576.977778 334.909759,573.122222 C338.809759,569.266667 345.065315,569.266667 348.965315,573.122222 L351.998648,570 L351.998648,577.911111 Z",
    id: "Shape"
  })))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRepeat, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/repeat.80ba2a30.svg";
export { ForwardRef as ReactComponent };